<template>
	<div class="retrievemark" v-if="isShow_retrievemark">
		<div id="jumpnextstep_wrap" v-if="isShow_retrievestep1">
			<div class="jumpnextstep_wrap_top">
				<span class="l_title_wrap" >找回密码</span>
				<span class="l_title_btn"  @click="closeretrievesteponepop" title="点击关闭"><i class="el-icon-close"></i></span>
			</div>
			<div class="jumpnextstep_wrap_main">
				<!--
                	作者：offline
                	时间：2018-10-31
                	描述：copy register 
                -->
				<div class="retrieve_phone">
					<input type="text" @blur="phoneVerification" placeholder="手机号" v-model="phone" />
					<span id="registerphoneme" ></span>
				</div>
				<div class="retrieve_ver">
					<input type="text" @blur="verificationVerification" placeholder="验证码" v-model="verification" />
					<span class="code1" @click="refreshCode">
    					<RIdentify :identifyCode="identifyCode"></RIdentify>
  					</span>
					<a @click="refreshCode" style="cursor: pointer;">换一张</a>
					<span id="verificationme"></span>
				</div>
				<div class="retrieve_sms">
					<input type="text" name="aa" placeholder="短信验证码" v-model="SMSverification" />
					<a id="sendsmsbtn" @click="getCode">{{codeStr}}</a>
					<span id="smsmessage"></span>
				</div>
				
				<div class="gonextstep" @click="jumpnextstep">
					下一步
				</div>
			</div>
		</div>

		<!--
        	作者：1272109752@qq.com
        	时间：2018-10-29
        	描述：questionpop
        -->
		<div id="retrieve_finish_wrap" v-if="isShow_retrievestep2">
			<div class="retrieve_finish_wrap_top">
				<span class="l_title_wrap" >找回密码</span>
				<span class="l_title_btn" @click="ccloseretrievesteptwopop" title="点击关闭"><i class="el-icon-close"></i></span>
			</div>
			<div class="retrieve_finish_wrap_main">
				
				<div class="newpwd">
					<input type="password" @blur="passwordVerification" placeholder="请输入新密码" v-model="password"/>
					<span id="newpwdmsg">
						
					</span>
				</div>
				<div class="newpwd1">
					<input type="password" @blur="cuePassword" placeholder="请再次输入新密码" v-model="password2"/>
					<span id="newpwdmsg1">
						
					</span>
				</div>
				<div class="retrievefinished" @click="closeretrievesteptwopop">
					完成
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import Bus from '@/bus.js'
	import RIdentify from '@/components/identify.vue'
	export default {
		data() {
			return {
				countdown:1,
				isShow_retrievemark: false,
				isShow_retrievestep1: false,
				isShow_retrievestep2: false,
				phone: '',
				verification: '',
				SMSverification: '',
				identifyCodes: "01234567890abcdefghijklmnopqrstuvwxyz",
				identifyCode: "",
				phoneCode:'',		//手机验证码
				password:'',		//密码
				password2:'',		//重复密码
				phone_f:'',
				verification_f:'',
				sms_f:'',
				timer_flag:true,
				codeStr:'发送短信验证码',
				password_f:'',
				cue_password_f:'',
				
				
			}
		},
		components: {
			RIdentify
		},
		destoryed(){
//			if(window.timer){
//				window.clearInterval(window.timer);
//			}
		},
		mounted() {
			this.identifyCode = "";
			this.makeCode(this.identifyCodes, 4);
		},
		methods: {
			// 手机号验证
			phoneVerification() {
				let that = this;
				let message = document.getElementById('registerphoneme')
				let reg = /^1[3-9]{1}[0-9]{9}$/;
				if(that.phone) {
					if(reg.test(that.phone)) {
						that.phone_f = 1;
						message.innerText = '';
						return true
					} else {
						message.innerText = '请输入正确的手机号'
						that.phone_f='';
						return false
					}
				} else {
					message.innerText = '手机号不能为空'
					that.phone_f='';
					return false
				}

			},
			// 验证码验证
			verificationVerification() {
				let that = this;
				let message = document.getElementById('verificationme')
				if(that.verification) {
					if(that.verification==that.identifyCode) {
						that.verification_f = 1;
						message.innerText = ''
						return true;
					} else {
						message.innerText = '验证码错误'
						that.verification_f = '';
						return false;
					}
				} else {
					message.innerText = '验证码不能为空'
					that.verification_f = '';
					return false;
				}

			},
			startTime(time){
				
				var timer = setInterval(() => {
					if(time == 0){
						this.timer_flag = true;
						this.codeStr = '发送短信验证码'
						clearInterval(timer)
					}else{
						this.codeStr = time + 's后重新发送'
						this.timer_flag = false
					}
					time--
				},1000)
			},
									//手机短信验证
			SMSVerification() {
				let _this=this;
				let message = document.getElementById('smsmessage')
				if(_this.SMSverification){
					_this.$http.get(_this.apiUrl+'index.php?m=Api&c=Login&a=verifyCode', {
						params: {
							'phone': _this.phone,
							'code': _this.SMSverification
						}
					}).then(
						response => {
							
							//进行数据验证
							if(response.body.status=='1'){
								_this.sms_f = true;
								if(_this.phone_f&&_this.sms_f&&_this.verification_f){
									_this.isShow_retrievestep1 = false;
									_this.isShow_retrievestep2 = true;
									
									_this.verification ='';
									_this.SMSverification='';
								}
								return ;
							}
							if(response.body.status=='2'){
							message.innerText='验证码错误';
							_this.sms_f = '';
								return false;
							};
							if(response.body.status=='3'){
							message.innerText='验证码失效';
							_this.sms_f = '';
								return false;
							}
						},
						response => {
//							console.log('error');
						}
					);
				}else{
					message.innerText='请输入短信验证码';
					_this.sms_f = '';
					return false;
				}
				
			},
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min)
			},
			refreshCode() {
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 4);
			},
			makeCode(o, l) {
				for(let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					];
				}
			},
			// 打开找回密码手机 验证页面
			openretrievesteponepop() {
				let that = this;
				that.isShow_retrievemark = true;
				that.isShow_retrievestep1 = true;
				that.isShow_retrievestep2 = false;
			},
			//关闭找回密码手机 验证页面
			closeretrievesteponepop() {
//				if(window.timer){
//				window.clearInterval(window.timer);
//				this.codeStr='发送短信验证码'
//				}
				let that = this;
				that.isShow_retrievestep1 = false;
				that.isShow_retrievemark = false
			},
			//下一步按钮点击事件
			jumpnextstep() {
//				this.phoneVerification();
				this.SMSVerification();
//				this.verificationVerification()
//				//判断验证码是否正确
//				if(this.phone_f&&this.sms_f&&this.verification_f){
//					this.isShow_retrievestep1 = false;
//					this.isShow_retrievestep2 = true;
//					
//					this.verification ='';
//					this.SMSverification='';
//				}else{
//					return 
//					this.$message({
//								message: '手机验证码错误',
//								type: 'warning',
//								customClass: 'message-warning',
//							});
//				}
				
			},
			openretrievesteptwopop() {
				var that = this;
				that.isShow_retrievestep2 = true;
			},
			//密码验证
			passwordVerification() {
				let that = this;
				let message = document.getElementById('newpwdmsg')
				let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
				if(that.password) {
					if(reg.test(that.password)) {
						that.password_f = true;
						message.innerText = '';
						return true;
					} else {
						that.password_f = '';
						message.innerText = '新密码格式错误';
						return false;
					}
				} else {
					that.password_f = '';
					message.innerText = '新密码不能为空';
					return false;
				}
			},
			//确认密码
			cuePassword() {				
				let message = document.getElementById('newpwdmsg1')
				let that = this;
				if(that.password2){
					if(that.password !== that.password2) {
					message.innerText = '两次密码不一致';
					that.cue_password_f=false;
					return false;
				} else {
					message.innerText = '';
					that.cue_password_f=true;
					return true;
				}
				}else{
					message.innerText = '请确认密码';
					that.cue_password_f=false;
					return false;
				}
				
			},
			//关闭
			ccloseretrievesteptwopop(){
				this.phone='';
				this.password='';
				this.password2='';
				this.isShow_retrievestep2 = false;
				this.isShow_retrievemark = false
			},
			//修改密码
			closeretrievesteptwopop() {
				var that = this;
				that.cuePassword();
				that.passwordVerification();
				if( that.password_f && that.cue_password_f ){
					//发送请求,修改密码
					this.$http.get(
						that.apiUrl+'index.php?m=Api&c=login&a=reset_passwords',
						{
							params: {  
								"phone":that.phone,
								'password':that.password
							}  
						}
					).then(response => {
						//进行数据验证
						if(response.body.status != 1){
							
							//显示错误页面
							this.$message({
								message: response.body.message,
								type: 'warning',
								customClass: 'message-warning',
							});
							return;
						}else{
							
							this.$message({
								message: '修改密码成功',
								type: 'success',
								customClass: 'message-warning',
							});
							
							if(localStorage.getItem('phone')==sessionStorage.getItem('phone')){
								localStorage.clear();
							};
							document.getElementById('home_head_exit').click()
							that.password='';
							that.password2='';
							that.isShow_retrievestep2 = false;
							that.isShow_retrievemark = false;
							that.$router.push({
								name:'enterPage',
								query:{
									're_phone':that.phone
								}
							})
							that.phone='';
						}
					}, response => {
//						console.log("error");
					});
				}
				
			},
			
			//发送验证码
			getCode(){
				let _this=this;
				//验证手机号和图形验证码...
				if(this.phoneVerification() && this.verificationVerification()){
//					if(true){
				//发送验证码
				if(this.timer_flag){
					
					this.timer_flag=false;
					this.$http.get(
					_this.apiUrl+'index.php?m=Api&c=login&a=sendCode',
					{
						params: {  
							"phone":this.phone,
							'type':'2'
						}  
					}
				).then(response => {
					//进行数据验证
					if(response.body.status != 1){
						//显示错误页面
						this.$message({
								message: response.body.message,
								type: 'warning',
								customClass: 'message-warning',
							});
						return;
					}
					this.startTime(60);
					this.phoneCode = response.body.data.code;
					this.$message({
							message: '验证码发送成功',
							type: 'success',
							customClass: 'message-warning',
						});
				}, response => {
//					console.log("error");
				});
				}
				}
			}
		}
	}
</script>

<style>
	#s-canvas{
		width: 100px;height: 40px;
	}
	#smsmessage,#verificationme,#registerphoneme{
		height: 20px;
		line-height: 20px;
		color: red;
		float: left;
		display: block;
		text-align: left;
		width: 355px;
	}
	#sendsmsbtn{
		cursor: pointer;
	}
	.retrieve_finish_wrap_main{
		width: 354px;
		height: 250px;
		margin:0 auto;
		margin-top: 40px;
		/*margin-bottom: 60px;*/
	}
	.newpwd,.newpwd1{
		margin: 0 auto;
		width: 354px;
		height: 68px;
	}
	.newpwd input,.newpwd1 input{
		width: 100%;
		height: 46px;
		border: 1px solid #999999;
		text-indent: 1em;
		border-radius: 4px;
		font-size: 16px;
	}
	.newpwd span,.newpwd1 span{
		display: block;
		 height:20px;
		line-height: 20px;
		color: red;
		text-align: left; 
	}
	.retrieve_phone,.retrieve_ver,.retrieve_sms{
		margin: 0 auto;
		width: 354px;
		height: 68px;
	}
	.retrieve_phone input{		
		width: 100%;
		height: 46px;
		border: 1px solid #999999;
		text-indent: 1em;
		border-radius: 4px;
		font-size: 16px;
	}
	.retrieve_phone #registerphoneme{
		height: 20px;
		line-height: 20px;
		color: red;
	}
	.retrieve_ver input{
		text-indent: 1em;
		float: left;
		width: 170px;
		height: 46px;
		border: 1px solid #999999;
		border-radius: 4px;
		font-size: 16px;
	}
	.retrieve_ver>.code1{
		float: left;
		width: 85px;
		display: block;
		height: 36px;
		padding: 5px 0;
		/*line-height: 46px;*/
		margin: 0 11px;
		border-radius: 4px;
	}
	.retrieve_ver>a{
		margin-left: 10px;
		width: 46px;
		line-height: 46px;
		border-radius: 4px;
		font-size: 16px;
		color: #4E95F6;		
	}
	.retrieve_sms input{
		border-radius: 4px;
		font-size: 16px;
		text-indent: 14px;
		width: 198px;
		height: 46px;
		border: 1px solid #999999;
		margin-left:-5px;
		
	}
	.retrieve_sms>a{
	
		border-radius: 4px;
		width: 144px;
		height: 46px;
		line-height: 46px;
		display: inline-block;
		border: 1px solid #999999;
		background: #E6F0FE;
		color:#4E95F6 ;
		
	}
	
	
	.retrievemark {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		background: rgba(0, 0, 0, .5);
	}
	
	
	#retrieve_finish_wrap,
	#jumpnextstep_wrap{
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 350px;
		border-radius: 5px;
	}
	
	#jumpnextstep_wrap .jumpnextstep_wrap_top {	
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #F3F7F9;
		width: 474px;
	}
	
	#jumpnextstep_wrap .jumpnextstep_wrap_main {
		width: 460px;
		margin: 0 auto;
		margin-top: 30px;
		height: 310px;
	}
	
	#retrieve_finish_wrap .l_title_wrap{
		float: left;display: block;height: 40px;line-height: 40px;font-size: 18px;
	}
	#retrieve_finish_wrap .l_title_btn{
		float: right;display: block;height: 40px;line-height: 40px;font-size: 24px;color: #AAAAAA;cursor: pointer;
	}
	#jumpnextstep_wrap .l_title_wrap{
		float: left;display: block;height: 40px;line-height: 40px;font-size: 18px;
	}
	#jumpnextstep_wrap .l_title_btn{
		float: right;display: block;height: 40px;line-height: 40px;font-size: 24px;color: #AAAAAA;cursor: pointer;
	}
	.jumpnextstep_wrap_main>.gonextstep {
		cursor: pointer;
		display: block;
		height: 40px;
		line-height: 40px;
		background: #076bf2;
		border-radius: 20px;
		font-size: 16px;
		width: 160px;
		margin: 10px auto;
		color: white;
	}
	#retrieve_finish_wrap .retrieve_finish_wrap_top {
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #F3F7F9;
		width: 474px;
	}
	
	
	#retrieve_finish_wrap .retrievefinished {
		display: block;
		height: 40px;
		line-height: 40px;
		background: #076bf2;
		cursor: pointer;
		/*background: -webkit-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -o-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -moz-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: linear-gradient(30deg, #65d2ff , #076bf2);*/
		border-radius: 20px;
		font-size: 16px;
		width: 160px;
		margin: 0 auto;
		margin-top: 60px;
		color: white;
	}
</style>


// WEBPACK FOOTER //
// src/messageBox/retrievepassword.vue